import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import LoginPage from './pages/Auth/LoginPage';
import OrdersPage from './pages/Orders/OrdersPage';
import OrderDetailPage from './pages/Orders/OrderDetailPage';
import { RepairsPage, RepairDetailPage } from './pages/Repairs/RepairsPages';
import { SuppliesPage, SupplyDetailPage } from './pages/Supplies/SuppliesPages';
import AdminPage from './pages/Admin/AdminPage';
import CatalogPage from './pages/Catalog/CatalogPage';
import ReportsPage from './pages/Reports/ReportsPage';
import WarehousePage from './pages/Warehouse/WarehousePage';
import { Spinner } from './components/common/UI';

function PrivateRoute({ children, adminOnly = false, producerOnly = false, reportsOnly = false }) {
  const { user, loading, isProducer, canAccessReports } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><Spinner size={32} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !['superadmin','producer_manager','dealer_admin'].includes(user.role)) return <Navigate to="/orders" replace />;
  if (producerOnly && !isProducer) return <Navigate to="/orders" replace />;
  if (reportsOnly && !canAccessReports) return <Navigate to="/orders" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><Spinner size={32} /></div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/orders" replace /> : <LoginPage />} />
      <Route path="/orders" element={<PrivateRoute><OrdersPage /></PrivateRoute>} />
      <Route path="/orders/:id" element={<PrivateRoute><OrderDetailPage /></PrivateRoute>} />
      <Route path="/repairs" element={<PrivateRoute><RepairsPage /></PrivateRoute>} />
      <Route path="/repairs/:id" element={<PrivateRoute><RepairDetailPage /></PrivateRoute>} />
      <Route path="/supplies" element={<PrivateRoute><SuppliesPage /></PrivateRoute>} />
      <Route path="/supplies/:id" element={<PrivateRoute><SupplyDetailPage /></PrivateRoute>} />
      <Route path="/catalog" element={<PrivateRoute producerOnly><CatalogPage /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute reportsOnly><ReportsPage /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><AdminPage /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/orders" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
